export const environment = {
  production: true,
  server: 'https://app.accorto.app',
  serverStage: 'https://app.accorto.us',
  ts: 'version=2021-08-13_09-02'
};
